import { useRef } from 'react';
import { Container } from 'typescript-ioc/es5';
export var useService = function useService(svc) {
  var svcRef = useRef(Container.get(svc));
  return svcRef.current;
};